module.exports = __webpack_public_path__ + "static/img/case1_4.jpeg";